// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"spinner_Spinner__2FLJ1","spin":"spinner_spin__1_Lqo"};